var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 5.5V13.9C12.8 14.0591 12.7368 14.2117 12.6243 14.3243C12.5117 14.4368 12.3591 14.5 12.2 14.5H3.8C3.64087 14.5 3.48826 14.4368 3.37574 14.3243C3.26321 14.2117 3.2 14.0591 3.2 13.9V5.5H2V4.3H14V5.5H12.8ZM4.4 5.5V13.3H11.6V5.5H4.4ZM5 2.5H11V3.7H5V2.5ZM7.4 7.3H8.6V11.5H7.4V7.3Z",
    fill: "#747E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteReport);
export default __webpack_public_path__ + "static/media/icon-delete-report.f741d1d42e5d01eb9a4d9c568a1358b6.svg";
export { ForwardRef as ReactComponent };